import axios from 'axios';
import { GuidService } from 'ui-components/services/guid-service';
import { PusherService } from '../../../services/pusher-service';
import { LogService } from '../../../services/log-service';
import { DIMENSIONALIZER, PRINTER, SCALE } from '../connect/constants';

const getBitValue = (value) => (value ? 1 : 0);
const getIntValue = (value) => (value ? parseFloat(value, 10) : undefined);

const REQUEST_PRINTER_CONFIG = 'connect:request:printer:config';
export const savePrinterConfig = ({ workstationId, device, userId }) => {
  const { id, name, shared, disabled, zplPrintSpeed, zplChunkSize, zplInvert, zplPrintSpeedRemoval } = device;
  const request = {
    requestId: GuidService.newGuid(),
    workstationId,
    userId,
    config: {
      id,
      name,
      shared: getBitValue(shared),
      disabled: getBitValue(disabled),
      zplPrintSpeed: getIntValue(zplPrintSpeed),
      zplChunkSize: getIntValue(zplChunkSize),
      zplInvert: getBitValue(zplInvert),
      zplPrintSpeedRemoval: getBitValue(zplPrintSpeedRemoval),
    },
  };
  PusherService.push(REQUEST_PRINTER_CONFIG, request, PusherService.getWorkstationChannelName(workstationId));
};

const REQUEST_SCALE_CONFIG = 'connect:request:scale:config';
export const saveScaleConfig = ({ workstationId, device, userId }) => {
  const {
    idFromConnect,
    name,
    shared,
    disabled,
    ssTimeout,
    deviceTimeout,
    weight1Byte,
    weight2Byte,
    weight1Factor,
    weight2Factor,
    readWait,
    retries,
  } = device;
  const request = {
    requestId: GuidService.newGuid(),
    workstationId,
    userId,
    config: {
      id: idFromConnect,
      name,
      shared: getBitValue(shared),
      disabled: getBitValue(disabled),
      ssTimeout: getIntValue(ssTimeout),
      deviceTimeout: getIntValue(deviceTimeout),
      weight1Byte: getIntValue(weight1Byte),
      weight2Byte: getIntValue(weight2Byte),
      weight1Factor: getIntValue(weight1Factor),
      weight2Factor: getIntValue(weight2Factor),
      readWait: getIntValue(readWait),
      retries: getIntValue(retries),
    },
  };
  PusherService.push(REQUEST_SCALE_CONFIG, request, PusherService.getWorkstationChannelName(workstationId));
};

const REQUEST_DIMENISONALIZER_CONFIG = 'connect:request:dimensionalizer:config';
export const saveDimensionalizerConfig = ({ workstationId, device, userId }) => {
  const { idFromConnect, name, shared, disabled, model, host, port } = device;

  const request = {
    requestId: GuidService.newGuid(),
    workstationId,
    userId,
    config: {
      id: idFromConnect,
      name,
      shared: getBitValue(shared),
      disabled: getBitValue(disabled),
      model,
      host,
      port,
    },
  };

  PusherService.push(REQUEST_DIMENISONALIZER_CONFIG, request, PusherService.getWorkstationChannelName(workstationId));
};

export const updateWorkstation = async (requestBody) => {
  try {
    const response = await axios.post('/workstations/update', requestBody);
    const result = response?.data ?? [];
    return result;
  } catch (error) {
    LogService.logError(error);
  }
};

export const deleteWorkstation = async (workstationId) => {
  try {
    const response = await axios.delete(`/workstations/deleteWorkstation/${workstationId}`);
    return response;
  } catch (error) {
    LogService.logError(error);
  }
};

export const updateConfigByDeviceType = {
  [PRINTER]: savePrinterConfig,
  [SCALE]: saveScaleConfig,
  [DIMENSIONALIZER]: saveDimensionalizerConfig,
};
